import styles from '@components/components/LogoOnlyNavigation/LogoOnlyNavigation.module.scss';
import logo from '@components/images/logo.include.svg';
import logoWhiteOutline from '@components/images/logo-white-outline.include.svg';
import { usePageData } from '@components/context';
import { useMedia } from '@components/hooks';
import React from 'react';
import { Link } from '@wienenergiegithub/ui-next';
import classNames from 'classnames';

const LogoOnlyNavigation = ({ theme }) => {
  const {
    layoutStructure: { logoLink, logoLinkDescription, background },
  } = usePageData();
  const isMobile = useMedia('(max-width: 767px)');
  const displayWhiteLogo =
    isMobile || theme === 'contrast' || background === 'orange-red-blue';

  return (
    <div className={styles.container} data-purpose="navigation">
      <Link
        aria-label={logoLinkDescription}
        className={classNames(styles.link, {
          [styles.whiteOutline]: displayWhiteLogo,
        })}
        to={logoLink}
      >
        <img
          alt="Wien Energie Logo"
          className={styles.logoImage}
          role="presentation"
          src={displayWhiteLogo ? logoWhiteOutline : logo}
        />
      </Link>
    </div>
  );
};

export default LogoOnlyNavigation;
